import { useEffect, useRef } from 'react';

const HeroSection = ({ onOrderClick }: { onOrderClick: () => void }) => {
  const bgRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (bgRef.current) {
        const scrollY = window.scrollY;
        bgRef.current.style.transform = `translateY(${scrollY * 0.45}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
      style={{ background: '#1e1e1e' }}
    >
      {/* Parallax Background */}
      <div
        ref={bgRef}
        className="absolute inset-0 will-change-transform"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=fire%20station%20apparatus%20bay%20interior%20dark%20industrial%20concrete%20walls%20dramatic%20lighting%20deep%20shadows%20firefighting%20equipment%20silhouettes%20moody%20atmospheric%20cinematic%20photography%20high%20contrast%20black%20charcoal%20tones&width=1920&height=1080&seq=hero-bg-001&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          top: '-15%',
          bottom: '-15%',
        }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80" />
      {/* Canvas texture overlay */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4'%3E%3Crect width='4' height='4' fill='%23222'/%3E%3Crect x='0' y='0' width='1' height='1' fill='%23333'/%3E%3Crect x='2' y='2' width='1' height='1' fill='%23333'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 flex flex-col items-center text-center">
        {/* Subtitle */}
        <p
          className="text-[#D4FF00] text-sm md:text-base tracking-[0.35em] uppercase mb-4 font-mono animate-fade-in"
          style={{ animationDelay: '0.1s' }}
        >
          Station House Supply Depot
        </p>

        {/* Main Title */}
        <h1
          className="text-5xl md:text-8xl font-black uppercase tracking-widest mb-4 animate-fade-in-up"
          style={{
            fontFamily: '"Black Ops One", "Impact", "Arial Black", sans-serif',
            background: 'linear-gradient(180deg, #ffffff 0%, #d0d0d0 50%, #a0a0a0 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textShadow: 'none',
            letterSpacing: '0.12em',
            animationDelay: '0.2s',
          }}
        >
          ZYN POUCH
        </h1>
        <h1
          className="text-5xl md:text-8xl font-black uppercase tracking-widest mb-8 animate-fade-in-up"
          style={{
            fontFamily: '"Black Ops One", "Impact", "Arial Black", sans-serif',
            background: 'linear-gradient(180deg, #ffffff 0%, #d0d0d0 50%, #a0a0a0 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            letterSpacing: '0.12em',
            animationDelay: '0.3s',
          }}
        >
          ORDERS
        </h1>

        {/* Payment notice */}
        <div
          className="border border-[#CE1126] px-6 py-3 mb-10 animate-fade-in"
          style={{ animationDelay: '0.4s' }}
        >
          <p className="text-white font-mono text-xs md:text-sm tracking-widest uppercase">
            <span className="text-[#CE1126] font-bold">VENMO PAYMENT REQUIRED</span>
            {' '}— Orders confirmed after payment only
          </p>
        </div>

        {/* CTA Button */}
        <button
          onClick={onOrderClick}
          className="group relative px-12 py-5 bg-[#CE1126] border border-[#C0C0C0] text-white font-black uppercase tracking-[0.25em] text-lg md:text-xl transition-all duration-200 hover:-translate-y-1 active:scale-95 whitespace-nowrap animate-fade-in-up cursor-pointer"
          style={{
            fontFamily: '"Black Ops One", "Impact", sans-serif',
            animationDelay: '0.5s',
          }}
        >
          <span className="relative z-10">DISPATCH ORDER</span>
          <div className="absolute inset-0 bg-white/0 group-hover:bg-white/10 transition-all duration-200" />
        </button>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#C0C0C0]/50 rounded-full flex items-start justify-center pt-2">
            <div className="w-1 h-3 bg-[#C0C0C0]/70 rounded-full animate-scroll-dot" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
